import React, { useEffect } from "react";
import { Route, Redirect, useHistory } from "react-router-dom";
import auth from "../auth/auth";
import TopNavBar from "../components/provider/navigation/topNavbar";
import { ValidateLocalStorageToken } from "../constants/provider/constant";

export const DashboardRouteProvider = ({ component: Component, ...rest }) => {
  const history = useHistory();
  const [searchDetails, setSearchDetails] = React.useState(null);
  const [searchAPIDetails, setSearchAPIDetails] = React.useState(null);
  const [selectedProviders, setSelectedProviders] = React.useState([]);
  const [resetFilters, setResetFilters] = React.useState(null);

  function resetFilter() {
    setSearchDetails(null);
    setSearchAPIDetails(null);
    setResetFilters(!resetFilters);
  }
  useEffect(() => {
    resetFilter();
  }, []);

  function searchById(value) {
    setSearchDetails(value);
    console.log("value", value);
  }

  function searchAPIDetailsFnc(value) {
    setSearchAPIDetails(value);
    console.log("value", value);
  }

  const providersUpdated = (value) => {
    setSelectedProviders(value);
  };

  if (!ValidateLocalStorageToken(localStorage.getItem("access_token"))) {
    history.push("/login");
    return null;
  } else
    return (
      <div className="pt-16">
        <div>
          <TopNavBar
            {...rest}
            resetFilters={resetFilters}
            onSearchById={searchById}
            onSearchedDetails={searchAPIDetailsFnc}
            onProvidersChanged={providersUpdated}
          ></TopNavBar>
        </div>
        <div>
          <Route
            {...rest}
            render={(props) => {
              if (
                auth.isAuthenticated() &&
                ValidateLocalStorageToken(
                  localStorage.getItem("user_details")
                ) &&
                ValidateLocalStorageToken(localStorage.getItem("user_details"))
                  ?.roleId === 5432
              ) {
                return (
                  <Component
                    {...props}
                    resetFilter={resetFilter}
                    searchAppointment={searchDetails}
                    searchAPIValues={searchAPIDetails}
                    selectedProviders={selectedProviders}
                  />
                );
              } else {
                return (
                  <Redirect
                    to={{
                      pathname: "/login",
                      state: {
                        from: props.location,
                      },
                    }}
                  />
                );
              }
            }}
          />
        </div>
      </div>
    );
};
